// extracted by mini-css-extract-plugin
export default {"paymentTimer":"iOg-H","container":"YoAI6","row":"jQxtM","timerWrapper":"S4Pzv","timer":"-aH7M","skeleton-progress":"uIZCv"};